import {Button, Modal} from "antd";
import React, {memo, useState} from "react";
import {InfoCircleTwoTone} from "@ant-design/icons";
import i18n from "../../../services/i18n";

const Description = () => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const button = (
        <div style={{textAlign: "center", width: "100%"}}>
            <b>{`"${i18n.containers.courses.CourseCreate.courseStepLessons.recalculateButton()}"`}</b>
        </div>
    );

    const description = (
        <span>
            <p>{"Hier können die Grundeinstellungen vorgenommen werden."}</p>
            <p>
                {"Um diese anzuwenden, klicke bitte auf den Button "}
                {button}
            </p>
            <p>
                {`Die bisherigen Kurseinheiten werden überschrieben. So lange der Kurs noch nicht gespeichert wurde, kannst du die Eingaben jederzeit widerrufen, indem du unten auf "Felder zurücksetzen" klickst.`}
            </p>
        </span>
    );

    return (
        <>
            <Modal
                title={i18n.containers.courses.CourseCreate.courseStepLessons.descriptionTitle()}
                style={{textAlign: "center"}}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                onOk={() => setModalOpen(false)}
                cancelButtonProps={{style: {display: "none"}}}
            >
                {description}
            </Modal>
            <Button
                type="text"
                size="large"
                style={{marginBottom: -5}}
                onClick={() => setModalOpen(!modalOpen)}
            >
                <span>{"Info"}</span>
                <InfoCircleTwoTone />
            </Button>
        </>
    );
};

export default memo(Description);
